import { subscribe } from "@shared/utils.events";
import { useSegment } from "./useSegment";

type Props = {
  carouselName: string;
  locationType: string;
  carouselName2?: string;
  locationTypeDetails?: string;
  tiles: {
    name: string;
    position: number;
    sku?: string;
    feature?: string;
    feature2?: string;
    feature3?: string;
  }[];
};

export const useCarouselViewedEvent = (): (() => void) => {
  const { track } = useSegment();

  return () => {
    subscribe("carousel viewed", (payload) => {
      const {
        carouselName,
        locationType,
        carouselName2,
        locationTypeDetails,
        tiles
      } = payload as Props;
      track({
        event: "Carousel Viewed",
        properties: {
          carousel_name: carouselName,
          location_type: locationType,
          ...(carouselName2 && { carousel_name2: carouselName2 }),
          ...(locationTypeDetails && {
            location_type_details: locationTypeDetails
          }),
          tiles: tiles.map((tile) => ({
            name: tile.name,
            position: tile.position,
            ...(tile.sku && { sku: tile.sku }),
            ...(tile.feature && { feature: tile.feature }),
            ...(tile.feature2 && { sku: tile.feature2 }),
            ...(tile.feature3 && { sku: tile.feature3 })
          }))
        }
      });
    });
  };
};
